import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  DoCheck
} from '@angular/core';
import { Router } from '@angular/router';
import { IActiveItem } from '../../interfaces/active-item.interface';
import { Field } from '@sitecore-jss/sitecore-jss/layout';
import { PortfolioService } from '../../services/portfolio.service';
import { PortfolioType } from '../../emuns/portfolio-type';

@Component({
  selector: 'ab-tab-navigation',
  templateUrl: './tab-navigation.component.html',
  styleUrls: ['./tab-navigation.component.scss']
})
export class TabNavigationComponent implements OnInit, DoCheck {
  @Input() rendering: any;
  @Input() activeMenu: string;

  @Output() change = new EventEmitter();

  tabs: IActiveItem[];

  constructor(
    private router: Router,
    private portfolioService: PortfolioService
  ) {}

  ngOnInit() {
    this.tabs = this.rendering.fields
      ? this.rendering.fields.Tabs
      : this.rendering;

    if (
      this.rendering.fields &&
      this.rendering.fields.IsRetailOnly &&
      this.rendering.fields.IsRetailOnly.lenght !== 0
    ) {
      this.portfolioService.getSelectedPortfolio().subscribe(portfolios => {
        if (
          PortfolioType[portfolios[0]?.portfolioType] ===
          PortfolioType.Corporate
        ) {
          this.rendering.fields.IsRetailOnly.forEach(nav => {
            const tabs = this.tabs.filter(n => n.id === nav.id);
            if (tabs) {
              this.tabs.splice(this.tabs.indexOf(tabs[0]), 1);
            }
          });
        }
      });
    }

    this.tabs.some(navigationLink => {
      const link: any = navigationLink.fields.Link;
      if (link) {
        navigationLink.isActive = this.router.url.indexOf(link.url) !== -1;
      }

      if (
        this.activeMenu &&
        (navigationLink.fields.Key as Field).value === this.activeMenu
      ) {
        navigationLink.isActive = true;
      }

      return navigationLink.isActive;
    });
  }

  ngDoCheck() {
    if (this.activeMenu) {
      this.tabs.forEach(navigationLink => {
        navigationLink.isActive =
          this.activeMenu === (navigationLink.fields.Key as Field).value;
      });
    }
  }

  selectActiveTab(item: IActiveItem) {
    if (item.isActive) {
      return;
    }

    this.tabs.forEach(i => (i.isActive = false));
    item.isActive = true;
    this.change.emit(item);
  }

  isTransfer(link) {
    if (!link) {
      return false;
    }

    return (
      link.url.indexOf('international') !== -1 ||
      link.url.indexOf('local') !== -1
    );
  }
}
